export const ROLES_TOAST_PREFIXES = {
    EDIT: 'Роль успешно отредактирована',
    CREATE: 'Новая роль успешно создана'
}

export const ROLES_FORM_TITLES = {
    EDIT: 'Редактирование роли',
    CREATE: 'Создание роли'
}
